module.exports = __webpack_public_path__ + "img/caritatriste.9f5bac17.png";